import { Clickable, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const FilterItem = ({ text, active, onClick }) => {
  return (
    <Clickable onClick={onClick}>
      <Row
        noFlex
        bg={active ? theme.SECONDARY : theme.GREY_10}
        pad="9px 24px"
        hasRadius="32px"
        marg="0 8px 0 0"
      >
        <Text med col={active ? '#fff' : '#000'}>
          {text}
        </Text>
      </Row>
    </Clickable>
  );
};

const Filters = ({ filter, handleFilterChange }) => {
  const { isMobile } = useSelector((state) => state.appState);
  const { t } = useTranslation();

  return (
    <Row noFlex wid={isMobile && '100%'}>
      <Row noFlex pad="0 16px" wid="100%" scrollX>
        <Row noFlex>
          <FilterItem
            text={t('store.liked')}
            active={filter === 'liked'}
            onClick={() => handleFilterChange('liked')}
          />

          <FilterItem
            text={t('store.merchandise')}
            active={filter === 'merchandise'}
            onClick={() => handleFilterChange('merchandise')}
          />

          <FilterItem
            text={t('store.tickets')}
            active={filter === 'ticket'}
            onClick={() => handleFilterChange('ticket')}
          />
        </Row>
      </Row>
    </Row>
  );
};

export default Filters;
